import firebaseConfig from "config/firebase";
import { getAnalytics, logEvent } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp); // for analytics
const auth = getAuth(firebaseApp); // For Authentication
const db = getFirestore(firebaseApp); // For Database

const logFirebaseAnalytics = (eventName: string, params?: any) => {
  logEvent(analytics, eventName, params);
};

export { auth, db, logFirebaseAnalytics, analytics };
